export enum SearchView {
    LIST = 'LIST',
    TABLE = 'TABLE',
}
